// extracted by mini-css-extract-plugin
var _1 = "ClientBundlesTableBodyRow_bundle__VdsDy";
var _2 = "ClientBundlesTableBodyRow_client__9yzBr";
var _3 = "ClientBundlesTableBodyRow_ended__XZkZl";
var _4 = "ClientBundlesTableBodyRow_services__elPHW";
export { _1 as "bundle", _2 as "client", _3 as "ended", _4 as "services" }
